/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { CenteredRadiantGradient, MetaData, StyledButton } from '@/components/atoms'
import { Footer, NavbarApp } from '@/components/molecules'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useEffect } from 'react'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const AboutUs = (props) => {
	const { t } = useTranslation('aboutus')
	const router = useRouter()
	const our_section = [
		{
			title: t('aboutus.our_history'),
			description1: t('aboutus.our_historyp1'),
			description2: t('aboutus.our_historyp2'),
			image: background_list.our1
		},
		{
			title: t('aboutus.our_philosophy'),
			description1: t('aboutus.our_philosophyp1'),
			description2: t('aboutus.our_philosophyp2'),
			image: background_list.our2
		},
		{
			title: t('aboutus.our_purpose'),
			description1: t('aboutus.our_purposep1'),
			description2: t('aboutus.our_purposep2'),
			image: background_list.our3
		},
	]
	
	const get_to_know_us = [
		{
			title: t('aboutus.our_team'),
			description: t('aboutus.our_team_desc'),
			route: route_list.our_team
		},
		{
			title: t('aboutus.our_career'),
			description: t('aboutus.our_career_desc'),
			route: route_list.career
		},
		{
			title: t('aboutus.our_event'),
			description: t('aboutus.our_event_desc'),
			route: route_list.agenda
		},
		{
			title: t('aboutus.our_press'),
			description: t('aboutus.our_press_desc'),
			route: route_list.press
		},
	]

	// useEffect(() => {
  //   window.fbq('track', 'VisitPage', {content_name: 'About Us Page'})
  // }, [])

	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 md:tw-px-0 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('aboutus.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
            {t('aboutus.description')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
						{our_section.map((item, index) => {
							const isZero = (index+1) % 2 === 0
							return (
								<div key={`our-section-${index}`} className="tw-flex tw-items-center md:tw-bg-transparent tw-bg-white tw-font-poppins tw-rounded-lg tw-mb-12">
									<div className="tw-justify-center tw-flex-1 tw-max-w-6xl md:tw-pt-4 tw-pt-0 tw-mx-auto md:tw-px-0">
											<div className={`tw-flex ${isZero ? 'md:tw-flex-row' : 'md:tw-flex-row-reverse'} tw-flex-col-reverse md:tw-gap-16`}>
													<div className="tw-w-full tw-mb-0 md:tw-w-1/2 md:tw-p-0 tw-p-5 md:tw-h-full ">
															<Image src={item.image} alt="" className="tw-relative tw-z-40 tw-object-cover tw-w-full md:tw-h-96 tw-rounded-xl" />
													</div>
													<div className="tw-w-full md:tw-px-10 tw-px-6 md:tw-py-7 tw-py-4 tw-mb-0 md:tw-w-1/2 md:tw-bg-white tw-bg-transparent tw-rounded-xl">
															<h2 className="tw-mb-4 md:tw-text-4xl tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">
																{item.title}
															</h2>
															<p className="tw-mb-10 tw-text-base tw-leading-7 tw-black">
																{item.description1}
															</p>
															<p className="md:tw-mb-0 tw-mb-0 tw-text-base tw-leading-7 tw-black">
																{item.description2}
															</p>
													</div>
											</div>
									</div>
								</div>
							)
						})}
						{/* vision mission */}
						<section className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg tw-mb-4">
							<div className="tw-justify-center tw-flex-1 tw-max-w-6xl tw-pt-4 tw-mx-auto md:tw-px-0">
									<div className="tw-flex md:tw-flex-row tw-flex-col	 tw-gap-5">
											<div className="tw-w-full md:tw-w-1/2 md:tw-mb-0 tw-rounded-xl">
													<h2 className="tw-mb-4 md:tw-text-4xl tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">
														{t('aboutus.vision')}
													</h2>
													<div className=' tw-bg-white tw-p-4 tw-rounded-xl tw-h-full'>
														<p className="tw-text-base tw-leading-7 tw-black tw-p-5 tw-py-2">
															{t('aboutus.vision_desc')}
														</p>
													</div>
											</div>
											<div className="tw-w-full md:tw-w-1/2 md:tw-mb-0 tw-rounded-xl">
													<h2 className="tw-mb-4 md:tw-text-4xl tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">
														{t('aboutus.mission')}
													</h2>
													<div className=' tw-bg-white tw-p-4 tw-rounded-xl tw-h-full'>
														<p className="tw-text-base tw-leading-7 tw-black tw-p-5 tw-py-2">
															{t('aboutus.mission_desc')}
														</p>
													</div>
											</div>
									</div>
							</div>
						</section>
						{/* story so far */}
						<section className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg tw-mb-4 tw-mt-24">
							<div className="tw-justify-center tw-flex-1 tw-max-w-6xl tw-pt-4 tw-mx-auto md:tw-px-0">
								<h2 className="tw-mb-4 md:tw-text-4xl tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-uppercase">{t('aboutus.our_story')}</h2>
									<div className="tw-flex md:tw-flex-row tw-flex-col	tw-gap-5">
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-row bg-yellow-green tw-p-4 tw-rounded-xl tw-items-center tw-justify-center tw-py-12 tw-text-white'>
														<span className=' tw-mr-5 tw-text-3xl tw-font-bold'>{t('aboutus.os_c1_n')}</span>
														<span>{t('aboutus.os_c1_t')} <br/> {t('aboutus.os_c1_b')}</span>
													</div>
											</div>
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-row bg-yellow-green tw-p-4 tw-rounded-xl tw-items-center tw-justify-center tw-py-12 tw-text-white'>
														<span className=' tw-mr-5 tw-text-3xl tw-font-bold'>{t('aboutus.os_c2_n')}</span>
														<span>{t('aboutus.os_c2_t')} <br/> {t('aboutus.os_c1_b')}</span>
													</div>
											</div>
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-row bg-yellow-green tw-p-4 tw-rounded-xl tw-items-center tw-justify-center tw-py-12 tw-text-white'>
														<span className=' tw-mr-5 tw-text-3xl tw-font-bold'>{t('aboutus.os_c3_n')}</span>
														<span>{t('aboutus.os_c3_t')} <br/> {t('aboutus.os_c3_b')}</span>
													</div>
											</div>
									</div>
							</div>
						</section>
						{/* Get To Know Us */}
						<section className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg tw-mb-4 tw-mt-24">
							<div className="tw-justify-center tw-flex-1 tw-max-w-6xl tw-pt-4 tw-mx-auto md:tw-px-0">
								<h2 className="tw-mb-4 md:tw-text-6xl tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">{t('aboutus.gtku')}</h2>
									<div className="tw-grid md:tw-grid-cols-2 tw-gap-5">
											{get_to_know_us.map((item, index) => {
												return (
													<button key={`get-to-know-${index}`} className="tw-w-full md:tw-mb-0 tw-rounded-xl tw-relative tw-text-left" onClick={() => router.push(item.route)}>
															<div className='tw-flex tw-flex-col tw-p-6 tw-rounded-xl tw-text-white tw-bg-[#004C42] tw-relative tw-overflow-hidden tw-h-full'>
																<Image src={background_list.card_wave_green} alt="arrow rotate" className='tw-absolute tw-top-0 tw-right-0 tw-z-0 tw-h-full' />
																<Image src={icon_list.arrow_rotate} alt="arrow rotate" className='tw-absolute tw-top-[10px] tw-right-[10px] tw-z-[1]' />
																<span className='tw-mr-5 tw-text-3xl tw-font-bold tw-z-[1]'>{item.title}</span>
																<span className='tw-z-[1]'>{item.description}</span>
															</div>
													</button>
												)
											})} 
									</div>
							</div>
						</section>
						{/* Recognition */}
						<section className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg tw-mb-4 tw-mt-24">
							<div className="tw-justify-center tw-flex-1 tw-max-w-6xl tw-pt-4 tw-mx-auto md:tw-px-0">
								<h2 className="tw-mb-4 md:tw-text-4xl tw-text-xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-center">{t('aboutus.recognition')}</h2>
									<div className="tw-flex md:tw-flex-row tw-flex-col	tw-gap-5">
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-col tw-p-4 tw-py-12 tw-gap-7'>
														<span className='tw-text-dark-green'>2023</span>
														<span className='tw-text-xl tw-font-bold'>TOP 39 Startup in SEA (South East Asia)</span>
														<span className='tw-text-dark-green tw-font-semibold'>TechinAsia</span>
													</div>
											</div>
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-col tw-p-4 tw-py-12 tw-gap-7'>
														<span className='tw-text-dark-green'>2023</span>
														<span className='tw-text-xl tw-font-bold'>Verified Tiktok Shop Partner (TSP) of 2023</span>
														<span className='tw-text-dark-green tw-font-semibold'>Tiktok Shop Partner</span>
													</div>
											</div>
											<div className="tw-w-full md:tw-w-1/3 md:tw-mb-0 tw-rounded-xl">
													<div className='tw-flex tw-flex-col tw-p-4 tw-py-12 tw-gap-7'>
														<span className='tw-text-dark-green'>2023</span>
														<span className='tw-text-xl tw-font-bold'>2nd ranking for highest GMV on Ramadhan sale</span>
														<span className='tw-text-dark-green tw-font-semibold'>Tiktok Service Provider</span>
													</div>
											</div>
									</div>
								<div className="tw-inline-flex tw-items-center tw-justify-center tw-w-full">
									<hr className="tw-w-[300px] tw-h-[1px] tw-my-8 tw-bg-dark-green tw-border-0 tw-rounded" />
									<div className="tw-absolute tw-px-4 -tw-translate-x-1/2 tw-bg-[#F1F1F1] tw-left-1/2">
										<h2 className="md:tw-text-xl tw-text-sm tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-center">{t('aboutus.many_more')}</h2>
									</div>
								</div>
							</div>
						</section>
						{/* Looking for a career opportunity?  */}
						<section className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg tw-my-24 tw-relative">
							<CenteredRadiantGradient />
							<div className="tw-justify-center tw-flex tw-items-center tw-flex-col tw-max-w-6xl tw-pt-4 tw-mx-auto md:tw-px-0 tw-gap-9">
								<h2 className="tw-mb-4 md:tw-text-7xl tw-text-3xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-pb-1 tw-from-dark-green tw-to-light-green tw-text-center">{t('aboutus.opportunity')}</h2>
								<StyledButton
									title={t('aboutus.view')}
									className='btn-dark-to-light-green-gradient tw-z-10 tw-text-white tw-font-semibold md:tw-text-lg tw-text-xs tw-items-center md:tw-px-12  tw-px-5 md:tw-py-4 tw-py-3 tw-rounded-full md:tw-flex '
									onClick={() => router.push(route_list.career)}
								/>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutUs

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'about-us'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

	return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'aboutus'])),
		},
	}
}
